module.exports = __webpack_public_path__ + "fonts/PrestigeEliteStd.fd0a32aa.woff";